import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import css from './SizeTile.module.scss'

export const SizeTile = observer(() => {
  const { size } = store.basic

  if (!size) return null

  return <Vertical className={css.tile} gap={12} opposite>
    <Typo one size={20}>
      {i18n('YourSize')}
    </Typo>
    <Typo line={32} size={48} semi>
      {size}
    </Typo>
  </Vertical>
})
